export const resolveAndCommentModalSelectors = {
  container: 'resolve-and-comment-modal',
  submitButton: 'resolve-and-comment-modal-submit-button'
};
